export default __webpack_public_path__ + "static/media/socialmediaPlatform.63ba5ff0.pdf";